package com.tovtalk.utils.language

import androidx.compose.runtime.compositionLocalOf

/**
 * CompositionLocal for current app language - shared across Android, iOS, Web.
 * Provided at root (TovTalkApp) from SettingsRepository.observeLanguage().
 */
val LocalAppLanguage = compositionLocalOf { LanguageCodes.ENGLISH }
